import { Controller } from "@hotwired/stimulus"
import { nextFrame } from "../helpers"

export default class extends Controller {
  static targets = ["toggle", "sidepane"]

  async initialize() {
    await nextFrame()
    if (this.hasToggleTarget && !this.hasSidepaneTarget) {
      this.toggleTarget.style.opacity = 0.25
      this.toggleTarget.style.pointerEvents = "none"
    }
  }

  toggle() {
    if (this.hasToggleTarget && this.hasSidepaneTarget) {
      this.sidepaneTarget.classList.toggle("hidden")
      this.toggleTarget.classList.toggle("active")
    }
  }
}
